import React from 'react';
import {theme, Typography} from "antd";

const ErrorBackend = () => {

    const { Title } = Typography;

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <div className="site-layout-content" style={{ background: colorBgContainer, display: 'flex', justifyContent: 'center' }}>
            <Title level={3}>
                Error Inesperado, vuelva a intentarlo mas tarde
            </Title>
        </div>
    );
}

export default ErrorBackend;